module.exports = __webpack_public_path__ + "static/media/8.question.e8743a0a.mp4";